import { createRoute } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import { createSignal } from "solid-js";
import { adminRoute } from "./admin";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { Tabs, TabsList, TabsPanel, TabsPanels, TabsTrigger } from "@/components/ui/tabs";
import { AdminBilling } from "@/features/finance/components/admin-billing";
// AUTONOMY: configuración de cobros self-service (métodos/planes/descuentos/recibo).
import { BillingSettings } from "@/features/finance/components/billing-settings";
// B3 · Operación de pasarelas: conciliación, drenaje y cola de webhooks.
import { GatewayPanel } from "@/features/finance/components/gateway-panel";

function AdminBillingPage() {
  const { t } = useI18n();
  const [tab, setTab] = createSignal("verification");
  return (
    <PageContainer maxWidth="4xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          title={t(msg`Billing`)}
          description={t(
            msg`Verify recorded payments, operate your payment gateways (state, money in flight, webhook queue) and configure how your academy charges.`,
          )}
        />
      </div>
      <div class="mt-4">
        <Tabs value={tab()} onChange={setTab}>
          <TabsList>
            <TabsTrigger value="verification">{t(msg`Verification`)}</TabsTrigger>
            <TabsTrigger value="gateways" data-testid="billing-gateways-tab">
              {t(msg`Gateways`)}
            </TabsTrigger>
            <TabsTrigger value="settings" data-testid="billing-settings-tab">
              {t(msg`Configuration`)}
            </TabsTrigger>
          </TabsList>
          <TabsPanels value={tab()} order={["verification", "gateways", "settings"]}>
            <TabsPanel value="verification">
              <div class="pt-4">
                <AdminBilling />
              </div>
            </TabsPanel>
            <TabsPanel value="gateways">
              <div class="pt-4">
                <GatewayPanel />
              </div>
            </TabsPanel>
            <TabsPanel value="settings">
              <div class="pt-4">
                <BillingSettings />
              </div>
            </TabsPanel>
          </TabsPanels>
        </Tabs>
      </div>
    </PageContainer>
  );
}

export const adminBillingRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/billing",
  component: AdminBillingPage,
});
